export default __webpack_public_path__ + "slices/main/assets/public/media/ca-logo-2x.e22dd517ae266c06e856821e82ac1c1a.png";